import React, {ReactNode} from 'react';
import ModalDialog from "@mui/joy/ModalDialog";
import intl from "react-intl-universal";

import type {ViewStoreModel} from "@stores/ViewStore";
import {AppState} from "@stores/AppState";
import {LogoIcon} from "../../../components/icons/LogoIcon";
import {getRedirectUrlAndRemoveItFromSearchParams} from "../../../../actions/redirect";
import {Button} from "../../../components/Button";
import {BackIcon} from "../../../components/icons/BackIcon";
import {AuthSocialRow} from "./AuthSocialRow";
import {initStateAuto} from "@stores/state";

import {Modal} from "../components/Modal";

import {inAppEventsHub} from "../../../../volatile/InAppEventsHub";


import './auth.css';


export interface AuthModalProps {
    children: ReactNode;
    isOpen: boolean;
    isBackVisible?: boolean;
    onClose: () => void;
}

export const AuthModal = (
    {
        children,
        isOpen,
        onClose,
        isBackVisible = false,
    }: AuthModalProps
) => {
    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            disableEscapeKeyDown
        >
            <ModalDialog
                layout={'fullscreen'}
                sx={{padding: 0}}
            >
                <div className='Auth'>
                    <div className='Auth-content-part'>
                        <div className={'Auth-logo-row'}>
                            <LogoIcon size={null} className={'Auth-logo'}/>
                        </div>
                        <div className='Auth-form'>
                            {children}
                        </div>
                        <div className={'Auth-logo-footer'}>
                            {
                                isBackVisible
                                    ? (
                                        <div className={'Auth-right'}>
                                            <Button
                                                type="neutral"
                                                style="plain"
                                                className={'Auth-back-btn'}
                                                onClick={() => {
                                                    inAppEventsHub.dispatch({
                                                        type: 'AuthBack',
                                                    })
                                                }}
                                                text={intl.get('common.back.to.login').d('BACK TO LOGIN ')}
                                                Icon={BackIcon}
                                                size={'sm'}
                                            />
                                        </div>
                                    )
                                    : (
                                        <AuthSocialRow/>
                                    )
                            }
                        </div>
                    </div>
                </div>
            </ModalDialog>
        </Modal>
    )
}

export interface AuthModalHeaderProps {
    title: string;
}

export const AuthModalHeader = ({title}: AuthModalHeaderProps) => {
    return (
        <h1 className={'AuthModalHeader headline-large-bold'}>
            {title}
        </h1>
    )
}

export const logIn = async (appState: AppState, viewStore: ViewStoreModel, username: string, password?: string, updateNameFields?: any) => {
    if (password) {
        const url = getRedirectUrlAndRemoveItFromSearchParams(viewStore);
        window.history.replaceState(null, '', url);

        const serviceRegistry = appState.getServiceRegistry();
        const authService = serviceRegistry.getAuthService();

        try {
            await authService.signIn(username, password);
        } catch (error: unknown) {
            if (error instanceof Error && error.name === 'UserAlreadyAuthenticatedException') {
                await initStateAuto(appState);
                return true;
            }
            throw error;
        }

        // Close auth modal immediately and show main loading
        appState.setModal(null);
        
        // Initialize state after modal is closed, skip modal handling since we already closed it
        await initStateAuto(appState, updateNameFields, true);
        return true;
    } else {
        appState.rootStore.view.openPageByName('sign-in', undefined, undefined, {
            emailDefaultValue: username
        });
        return false;
    }
}
